<template>
  <div class="subbanner">
    <div class="container">
      <div class="subbanner-row">
        <slot name="filters"></slot>
        <slot name="languageSwitcher"></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.subbanner {
  border-bottom: 2px solid #000;

  @media (max-width: 640px) {
    .container {
      padding: 0;
    }
  }
}

.subbanner-row {
  display: flex;
  justify-content: space-between;
}
</style>
